module.exports = __webpack_public_path__ + "static/media/august.9f3950d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/august.mp3
// module id = nZz4
// module chunks = 1